<template>
    <div class="mine-user-info-view">
        <button class="mine-user-info-view-avatar" @click="onAvatarClick">
            <img class="mine-user-info-view-avatar-content" :src="avatarIcon">
        </button>
        <div class="mine-user-info-view-right">
            <div class="mine-user-info-view-right-top">
                <p>{{ userName }}</p>
                <p>{{ userGender }}</p>
                <p>{{ userAge }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import API from "@/api";
import { mapState } from 'vuex';
export default {
    data() {
        return {
            userInfoModel: undefined,
            GenderEnum: [{
                value: 1,
                label: '男'
            },
            {
                value: 2,
                label: '女'
            }],
            placeholderAvatarIcon: require('@img/mine-avatar.png')
        };
    },
    computed: {
        avatarIcon() {
            return this.userInfoModel?.headUrl?.length ? this.userInfoModel?.headUrl : this.placeholderAvatarIcon;
        },
        userName() {
            return this.placeholderText(this.userInfoModel?.trueName);
        },
        userGender() {
            return this.placeholderText(this.userInfoModel?.sex ? this.GenderEnum.find(el => el.value === this.userInfoModel?.sex)?.label : '男');
        },
        userAge() {
            return this.placeholderText(this.userInfoModel?.age, '岁');
        },
        ...mapState(['user'])
    },
    methods: {
        placeholderText(text, suffix = '') {
            return text || `未知${suffix}`;
        },
        onAvatarClick() {
            this.$emit("onItemClick", "编辑用户");
        },
        onStatusClick() {
            this.$emit("onItemClick", "我的服务包");
        },
        async getUserInfo() {
            try {
                this.userInfoModel = await API.userInfoRequest({ id: this.user.user.uid });
            } catch (error) {
                console.log(error);

                this.$toast(error);
            }
        }
    },
    mounted() {
        this.getUserInfo();
    }
};
</script>

<style lang="scss" scoped>
.mine-user-info-view {
    display: flex;
    align-items: center;

    &-avatar {
        width: 60px;
        height: 60px;

        &-content {
            width: 100%;
            height: 100%;
            border-radius: 30px;
        }
    }

    &-right {
        height: 54px;
        box-sizing: border-box;
        padding: 3px 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 12px;

        &-top {
            color: white;
            display: flex;
            align-items: center;

            >p {
                font-size: 12px;
                margin-right: 12px;
                position: relative;
            }

            :first-child {
                font-size: 18px;
            }
        }

        &-bottom {
            color: white;
            font-size: 12px;
            display: flex;
            align-items: center;

            &-arrow {
                width: 6px;
                height: 10px;
                margin-left: 6px;
            }
        }
    }
}
</style>